import React from 'react';
import PropTypes from 'prop-types';

import { createReactFormValidator, range, required, positiveInteger } from '../../../../../utils/validation';
import {
    Input,
} from '../../../../Form';
import { acceptanceBucketTypes } from '../../../../../utils/eventConstants';

const Buckets = (props) => {
    const {
        field,
        buckets,
        divisionIndex,
        acceptanceListRoundTypes,
        isDivisionSingles,
    } = props;

    const mainRound = acceptanceListRoundTypes.find(rt => rt.value === acceptanceBucketTypes.MAIN);
    const getQualifyingDrawLabel = (isDivisionSingles) => {
        return `How many ${isDivisionSingles ? 'players' : 'teams'} will be directly accepted into the qualifying draw?`;
    };

    const getMainDrawLabel = (isDivisionSingles) => {
        return `How many ${isDivisionSingles ? 'players' : 'teams'} will be directly accepted into the main draw?`;
    };

    return (
        <>
            {buckets.map((draw, j) => {
                let inputLabel = getQualifyingDrawLabel(isDivisionSingles);
                let inputMin = 0;
                let inputMax = null;
                let inputValidators = createReactFormValidator([positiveInteger, range(0, 256)]);

                if (draw.type === mainRound.id) {
                    inputLabel = getMainDrawLabel(isDivisionSingles);
                    inputMin = 1;
                    inputMax = 256;
                    inputValidators = createReactFormValidator([required, range(1, 256), positiveInteger]);
                }

                return (
                    <Input
                        id={`division-${divisionIndex}-acceptance-list-draw-count-${j}`}
                        key={`acceptance-list-draw-count-${j}`}
                        label={inputLabel}
                        field={[field, divisionIndex, 'acceptance', 'list', 'buckets', j, 'count']}
                        type="number"
                        min={inputMin}
                        max={inputMax}
                        validate={inputValidators}
                        data-testid="event-edit.division-item-acceptance-list--input"
                    />
                );
            })}
        </>
    );
};

Buckets.propTypes = {
    field: PropTypes.string.isRequired,
    buckets: PropTypes.objectOf(Array).isRequired,
    divisionIndex: PropTypes.number,
    acceptanceListRoundTypes: PropTypes.objectOf(Array).isRequired,
    isDivisionSingles: PropTypes.bool,
};

Buckets.defaultProps = {
    divisionIndex: 0,
    isDivisionSingles: true,
};

export default Buckets;
